import dayjs from "dayjs";
import { getUser } from "shj-utils";
const getConfig = () => {
  const userInfo = getUser()
  return {
    rowSelection: false,
    columns: [
      {
        title: '分公司',
        width: 150,
        dataIndex: 'orgName'
      },
      {
        title: '部门',
        width: 150,
        dataIndex: 'deptName'
      },
      {
        title: '员工',
        width: 150,
        dataIndex: 'tenantName'
      },
      {
        title: '线索ID',
        dataIndex: 'clueId',
        width: 180,
        fixed: 'left',
        render: 'idJump'
      },
      {
        title: '电话号码',
        dataIndex: 'calledNo',
        width: 180,
      },
      {
        title: 'IP归属地',
        dataIndex: 'address',
        width: 150,
      },
      {
        title: '呼叫时间',
        dataIndex: 'ring',
        itemType: 'dateTime',
        width: 150,
      },
      {
        title: '通话时长（秒）',
        dataIndex: 'callTimeLength',
        width: 150
      },
      {
        title: '接听状态',
        dataIndex: 'callStateName',
        width: 150,
        // render:callStateName
      },
      {
        title: '外呼话费（元）',
        dataIndex: 'callCost',
        width: 150,
      },

      {
        title: '操作',
        dataIndex: 'bindType',
        width: 180,
        render: 'operation',
        fixed: 'right'
      }
    ],
    search: [
      {
        name: 'clueId',
        label: '线索ID',
        formItemProps: {
          getValueFromEvent: (e) => e?.target?.value.replace(/\D.*/, ''),
        },
      },
      {
        name: 'calledNo',
        label: '客户号码',
        formItemProps: {
          getValueFromEvent: (e) => e?.target?.value.replace(/\D.*/, ''),
        },
      },
      {
        name: 'state',
        label: '接听状态',
        itemType: 'select',
        data: 'answerState',
        labelKey: 'description'
      },
      {
        name: 'callTime',
        label: '呼叫时间',
        itemType: 'autoDate',
      },
      {
        name: 'duration',
        label: '通话时长',
        itemType: 'custom',
        render: 'duration'
      },
      {
        name: 'orgId',
        label: '分公司',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
        events: ['onChange:onCompanyChange'],
        disabled: userInfo?.userIdentity?.dataScope !== 'ALL',
      },
      {
        name: 'deptId',
        label: '部门',
        itemType: 'cascader',
        events: ['onChange:onDeptCodeChange'],
        key: 'id',
        labelKey: 'label',
        value: 'id',
        data: 'deptId',
        notFoundContent: '请选择公司或无匹配数据',
        changeOnSelect: true,
        expandTrigger: 'hover',
      },
      {
        name: 'userId',
        label: '员工',
        itemType: 'select',
        data: 'employ',
        labelKey: 'userName',
        key: 'ucenterUserId',
        notFoundContent: '请选择公司或无匹配数据',
      },
      {
        name: 'type',
        label: '外呼服务商',
        itemType: 'select',
        data: 'serviceList',
        labelKey: 'description',
        key: 'key',
      },
    ],
    searchInitialValues: {
      callTime: [dayjs().startOf('month'), dayjs()],
    },
    footer: [
      {
        label: '导出',
        render: 'exportRender',
      }
    ]
  }
}
export default getConfig()
